import { APIService } from "../../common/API";
import GetCurrentUser, { parsedUser } from "@/common/GetCurrentUser";
import ActionBar from "@/components/core/ActionBar";
import { Routes } from "@/routes";
import { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams, useLocation } from "react-router-dom";

const AgentsPage = () => {
    const { t } = useTranslation();

    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [records, setRecords] = useState([]);
    const user = parsedUser();
    const bindData = async () => {
        try {
            setIsLoading(true);

            let request = await APIService.getAction("users/list?organizationId=" + user.OrganizationId);
            if (request.data.status === "ok") {
                // Process the response data as needed
                setRecords(request.data.response || []);
            }
        }
        catch (ex) {
            // Error handled - request failed
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        bindData();
    }, []);

    return <Container className="py-4 ">
        <ActionBar
            title={t("Agents")}
            icon="fa fa-users me-2 "
            actions={
                <div className="btn-group">
                    {isLoading && <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>}
                </div>
            }
        ></ActionBar>
        {records.length > 0 &&
            < Card className="mt-4">
                <Card.Body className="p-0">
                    {records.map((agent: any) => (
                        <Row className="clickable mx-0" key={agent.id} onClick={() => { history.push(`${Routes.AgentDetails.clean}${agent.id}`) }}>
                            <Col xs={12}>
                                <span className="badge bg-primary">{agent.organizationRoleName}</span>
                                <br />
                                <b>{`${agent.firstName} ${agent.lastName}`}</b>
                                <br />
                                <small>{agent.email}</small>
                                <hr />
                            </Col>
                        </Row>
                    ))}

                </Card.Body>
            </Card>}
    </Container >
};

export default AgentsPage;